import { axiosInstance } from '@services/base-service';

const coreOperationsUri = '/merchant/bff/core-operations';

export const resendInvitation = () =>
  axiosInstance.getInstance().post(`${coreOperationsUri}/resend/welcome-invitation`);
